module.exports = __webpack_public_path__ + "components/flag/static/square/fo-a0ffee11931a86857d9d76436203b570.svg";